import React from 'react';

const formatDate = (value) => value ? new Date(value).toLocaleString('ru-RU') : '—';
const formatDuration = (seconds) => {
  const value = Math.max(0, Number(seconds || 0));
  const h = Math.floor(value / 3600);
  const m = Math.floor((value % 3600) / 60);
  return h ? `${h}ч ${m}м` : `${m}м`;
};

const SystemMonitorUserHistory = ({ data, loading, onClose }) => {
  if (!data && !loading) return null;
  const totals = data?.totals || {};
  return (
    <div className="systemMonitor__historyOverlay" onClick={onClose}>
      <div className="systemMonitor__historyModal" onClick={(e) => e.stopPropagation()}>
        <div className="systemMonitor__sectionHead">
          <div>
            <div className="systemMonitor__sectionTitle">История пользователя</div>
            <div className="systemMonitor__sectionHint">{data?.user?.name || 'Загрузка…'} · {data?.user?.email || ''}</div>
          </div>
          <button type="button" className="systemMonitor__miniBtn" onClick={onClose}>Закрыть</button>
        </div>

        {loading ? <div className="systemMonitor__empty">Загрузка истории…</div> : (
          <>
            <div className="systemMonitor__statsGrid is-compact">
              <div className="systemMonitor__statCard"><span>Сессий</span><strong>{totals.sessions || 0}</strong></div>
              <div className="systemMonitor__statCard"><span>Активное время</span><strong>{formatDuration(totals.activeSeconds)}</strong></div>
              <div className="systemMonitor__statCard"><span>Страниц</span><strong>{totals.pageViews || 0}</strong></div>
              <div className="systemMonitor__statCard"><span>API</span><strong>{totals.apiRequests || 0}</strong></div>
              <div className="systemMonitor__statCard"><span>Socket</span><strong>{totals.socketEvents || 0}</strong></div>
            </div>
            <div className="systemMonitor__historyTimeline">
              {(data?.visits || []).slice(0, 300).map((visit) => (
                <div className="systemMonitor__historyRow" key={visit.visitId}>
                  <div><strong>{visit.route}</strong><small>{visit.source?.toUpperCase()}</small></div>
                  <div>{formatDate(visit.enteredAt)}</div>
                  <div>{formatDuration(visit.activeSeconds)}</div>
                </div>
              ))}
              {!data?.visits?.length ? <div className="systemMonitor__empty">Сохранённых переходов пока нет.</div> : null}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SystemMonitorUserHistory;
